(() => {
  if (customElements.get('sk-water-resin-selector')) return;

  class WaterResinSelector extends HTMLElement {
    connectedCallback() {
      if (this.dataset.skWaterReady) return;
      const select = this.querySelector('[data-sk-water-select]');
      const field = this.querySelector('[data-sk-water-select-field]');
      const panels = [...this.querySelectorAll('[data-sk-water-panel]')];
      if (!select || !field || !panels.length) return;

      const showSelected = () => {
        const selected = panels.find(panel => panel.id === select.value);
        if (!selected) return;
        panels.forEach(panel => { panel.hidden = panel !== selected; });
      };
      select.addEventListener('change', showSelected);
      this.querySelectorAll('.sk-growth-picker-nav a').forEach(link => {
        link.addEventListener('click', event => {
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#')) return;
          const target = document.getElementById(href.slice(1));
          if (!target) return;
          const panel = target.closest('.tabs-component-content');
          if (panel && panel.getAttribute('aria-hidden') === 'true') {
            const owner = panel.closest('[data-sk-tabs]');
            const navigation = owner && owner.querySelector('tabs-navigation');
            const trigger = navigation && [...navigation.querySelectorAll('[data-handle]')]
              .find(item => item.getAttribute('data-handle') === panel.getAttribute('data-handle'));
            if (!trigger || typeof navigation.setActiveTab !== 'function') return;
            navigation.setActiveTab(trigger);
          }
          event.preventDefault();
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - 120), behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      showSelected();
      field.hidden = false;
      this.classList.add('is-ready');
      this.dataset.skWaterReady = 'true';
    }
  }

  customElements.define('sk-water-resin-selector', WaterResinSelector);
})();
